// rwr – Size Guide FAQs
// Currently just adds a class when a FAQ row is open (handy for extra styling if needed)

document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.rwr-faq-item');
  if (!items.length) return;

  items.forEach((item) => {
    item.addEventListener('toggle', () => {
      item.classList.toggle('rwr-faq-item--open', item.open);
    });
  });
});
